export const ARTICLE_SEO_SITE_TITLE = 'dスマホローン | カードがいらないドコモのカードローン';

export const ARTICLE_SEO_TITLE_SEPARATOR = ' | ';

/**
 * Build article page title with common site title suffix.
 * @param title - Article specific title text.
 * @returns Title combined with the site title suffix.
 */
export const withArticleSeoTitle = (title: string): string =>
  `${title}${ARTICLE_SEO_TITLE_SEPARATOR}${ARTICLE_SEO_SITE_TITLE}`;

export const ARTICLE_SEO_COMMON_DESCRIPTION =
  'dスマホローンは、NTTドコモ・フィナンシャルグループが提供するスマホ完結のローンサービスです。カードがいらないカードローン。お申込みからご契約、お借入れ・ご返済もスマホにて完結。ドコモ回線やその他ドコモグループのサービスのご利用状況に応じて最大年率3.0％も金利優遇！';

export const SEO_COMMON_DESCRIPTION =
  'dスマホローンは、NTTドコモ・フィナンシャルグループが提供するスマホ完結のローンサービスです。';

export const ARTICLE_SEO_KEYWORDS = 'dスマホローン,ドコモ';

export const ARTICLE_SEO_SITE_NAME = 'dスマホローン';
